export default __webpack_public_path__ + "static/media/userECommerce.25ee3818.png";